import React from "react";
import { Container } from "react-bootstrap";

export const Catalogs: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Catalogs
            </Container>
        </React.Fragment>
    );
}